export default __webpack_public_path__ + "assets/images/c81b3960db81bcf5032a2e3a4686ed5a.svg";